import { navigate } from '@/common/agents';

const TEAM_STUDIO_ROUTE_COVER_ID = 'roboneo-team-studio-route-cover';

type TeamStudioNavigateOptions = Parameters<typeof navigate>[0];

/** 在 Team Studio 整页跳转前覆盖当前页面，并等遮罩绘制后再执行跳转。 */
function withTeamStudioRouteCover(callback: () => void) {
  if (typeof document === 'undefined') {
    callback();
    return;
  }

  if (!document.getElementById(TEAM_STUDIO_ROUTE_COVER_ID)) {
    const cover = document.createElement('div');
    const fallbackBackground = document.body.getAttribute('roboneo-data-theme') === 'light'
      ? '#eff1f4'
      : '#0a0a0a';
    cover.id = TEAM_STUDIO_ROUTE_COVER_ID;
    cover.style.cssText = `position:fixed;inset:0;z-index:10000;background:var(--background-canvas, ${fallbackBackground});pointer-events:none;`;
    document.body.appendChild(cover);
    window.setTimeout(() => cover.remove(), 5000);
  }

  if (!window.requestAnimationFrame) {
    callback();
    return;
  }

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(callback);
  });
}

/** Team Studio 整页跳转前先绘制主题遮罩，再沿用现有 navigate 行为。 */
export function navigateWithTeamStudioCover(options: TeamStudioNavigateOptions) {
  withTeamStudioRouteCover(() => {
    navigate(options);
  });
}
